import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./Dropdown.module.scss"
import { CaretDownIcon } from "src/icons"

export type Props = ComponentPropsWithoutRef<"svg">

/*
 * this element renders the down caret icon that indicates to the user that
 * there is a select element
 */
export const DropdownCaret = forwardRef<SVGElement, Props>(
  function DropdownCaret(props: Props, propRef: Ref<SVGElement>) {

    const className = classNames(
      styles.dropdownCaret,
      props.className,
    )

    return (
      <CaretDownIcon
        {...props}
        ref={propRef}
        className={className}
      />
    )
  },
)
